import DarkModeToggle from "../shared/DarkModeToggle";
import { AppBar, Container, Toolbar, Typography } from "@mui/material";

export default function ResultsAppBar() {
  return (
    <AppBar position="static" elevation={0}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
            Skrutiner Results
          </Typography>
          <DarkModeToggle />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
